import { SelectableWithIdObject } from "src/components/Form/types";
import { formatValidPeriod } from "src/services/formatters";
import { ValidPeriodResponse } from "src/shared/api-types/course";

import request from "./request";

export class ValidPeriod extends SelectableWithIdObject {
  public validPeriod: number | null;

  constructor(data: ValidPeriodResponse) {
    super(data.id);
    this.validPeriod = data.validPeriod;
  }

  getDisplayName(t?: (key: string, options?: object) => string): string {
    return formatValidPeriod(this.validPeriod, t);
  }
}

export const mapValidPeriod = (data: ValidPeriodResponse): ValidPeriod => {
  return new ValidPeriod(data);
};

export const getValidPeriods = async (): Promise<ValidPeriod[]> => {
  const response = await request(`/valid_periods`);
  return response.map((data: ValidPeriodResponse) => mapValidPeriod(data));
};
